import { render, staticRenderFns } from "./LoanTypeDetailsModal.vue?vue&type=template&id=73dcbba6"
import script from "./LoanTypeDetailsModal.vue?vue&type=script&lang=js"
export * from "./LoanTypeDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports